<template>
  <div class="">
    <div v-if="!already"
         class="cn-container">
      <span class='text'>{{ text }}</span>
      <button class="ui button basic positive"
              @click="signUp()">
        <i class="icon bell"></i>{{ trans.signUp }}
      </button>
    </div>
    <div v-else
         class="cn-container">
      <span class='text'>{{ trans.textIfAlready }}</span>
      <button v-if="already"
              class="ui negative button basic mini"
              @click="signDown()">
        <i class="icon bell"></i>{{ trans.signDown }}
      </button>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import {doSignDown, doSignUp} from '@/store/cancelNotification';
//import notify from '../../notify';


export default {
  props: ['from_time', 'subjectId', 'subjectTypeName'],
  data () {
    return {};
  },
  computed: {
    ...mapState({
      trans: (state) => state.trans.cancelNotification.extra,
    }),
    text () {
      return this.$store.state.trans.cancelNotification.extra.text.replace('$subjext-type-name$', this.subjectTypeName)
    },
    already () {
      let cns = this.$store.state.cancelNotification.items;
      return (cns.indexOf(this.from_time) >= 0);
    },
  }, // computed

  methods: {
    beforeModalOpen (event) {
      this.subject = event.params.subject;
      this.from_time = event.params.from_time;
      console.log('subject', this.subject);
    },
    close () {
      this.$modal.hide('cancel-notification-modal');
    },
    signUp () {
      let data = { subject_id: this.subjectId, from_time: this.from_time };
      this.$store.dispatch(doSignUp, data)
      /*.then((response) => {
        notify.success(response.body.msg);
      });*/
    },
    signDown () {
      let data = { subject_id: this.subjectId, from_time: this.from_time };
      this.$store.dispatch(doSignDown, data)
      /*.then((response) => {
        notify.success(response.body.msg);
      });*/
    },
  }, // methods
};
</script>

<style scoped>
.cn-container {
  display: flex;
  align-items: center;
}

.button > i {
  display: inline;
}

.text {
  text-align: left;
  padding-right: 1em;
}
</style>
